import type { SelectOption } from '@aus-platform/design-system';
import { BaseReference, HeapCategory, HeapMaterialType } from 'shared/api';
import {
  baseReferenceLabel,
  materialTypeOptions,
  volumeCategoryOptions,
} from '../../constants';

import type { HeapInputFieldType } from './types';

export const baseReferenceOptions: SelectOption[] = [
  {
    label: baseReferenceLabel[BaseReference.VisibleGround],
    value: BaseReference.VisibleGround,
  },
  {
    label: baseReferenceLabel[BaseReference.SiteBaseDsm],
    value: BaseReference.SiteBaseDsm,
  },
  {
    label: baseReferenceLabel[BaseReference.OtherIterationDsm],
    value: BaseReference.OtherIterationDsm,
  },
];

export const heapInitialState: HeapInputFieldType = {
  otherIteration: null,
  baseReference: baseReferenceOptions[0],
  heapName: '',
  heapDescription: null,
  bulkDensity: null,
  materialType: materialTypeOptions.find(
    (option) => option.value === HeapMaterialType.Other,
  )!,
  category: volumeCategoryOptions.find(
    (option) => option.value === HeapCategory.Other,
  )!,
  workspaceLayer: null,
};
